/* ==========================================================================
   SearcherFerryHotel > Client > Accomodation > discounts
   ========================================================================== */
/* Modules */
const { html } = require('common-tags');
const { addData } = require('@bluekiri/alexandria/helpers/dataHelpers');

const SelectTemplate = require('@bluekiri/alexandria-contrib-components/components/select-rxjs/template');
const SelectClient = require('@bluekiri/alexandria-contrib-components/components/select-rxjs/client/js');
const SelectClientActions = require('@bluekiri/alexandria-contrib-components/components/select-rxjs/client/js/store/actions');

const configuration = require('../../config');

function buildInfoDiscounts(instance) {
    const { discounts = {}, bonus = {} } = instance.store.select('data');

    const discountsText = discounts.label && discounts.value ? `, ${discounts.label}` : '';
    const bonusText = bonus.label && bonus.value ? `, ${bonus.label}` : '';

    return `${discountsText} ${bonusText}`;
}

function loadInfoDiscounts(instance) {
    if (!instance.accommodationInput) return;

    const inst = instance;

    const accommodationInfo = buildInfoDiscounts(inst);
    const inputText = inst.accommodationInput.input.hooks.input.value.split(',');

    inst.accommodationInput.actions.changeValue(
        `${inputText[0].trim()}, ${inputText[1].trim()} ${accommodationInfo.trim()}`
    );
    inst.accommodationInput.input.hooks.input.title = `${inputText[0]}, ${inputText[1]} ${accommodationInfo.trim()}`;
}

function getSelectData(items, value) {
    return items.map(option => {
        const { name, type } = option;
        return {
            label: name,
            value: type,
            selected: value === type
        };
    });
}

function initDiscounts(instance) {
    const inst = instance;

    /* Data Panel */
    const { panelType } = instance.accommodationInput.store.select('data');
    const panelSelector = `[data-type="${panelType}"]`;

    if (!instance.accommodation) return;

    inst.discounts = SelectClient(
        `${panelSelector} [data-component="SelectRxjs"][data-type="${configuration().type.discount}"]`
    );

    if (!inst.discounts) return;

    /* Extend reactions */
    inst.reactions = {
        ...inst.reactions,
        selectOptionDiscount: inst.discounts.store.subscribe((state, action) => {
            if (action.type !== SelectClientActions.types.SELECT_OPTION) return;

            /* Data discounts */
            const { value } = inst.discounts.store.select('select');

            /* Sync store */
            instance.actions.changeData({
                discounts: value
            });

            loadInfoDiscounts(inst);
        })
    };
}

function initBonus(instance) {
    const inst = instance;

    /* Data Panel */
    const { panelType } = instance.accommodationInput.store.select('data');
    const panelSelector = `[data-type="${panelType}"]`;

    if (!instance.accommodation) return;

    inst.bonus = SelectClient(
        `${panelSelector} [data-component="SelectRxjs"][data-type="${configuration().type.bonus}"]`
    );

    if (!inst.bonus) return;

    /* Extend reactions */
    inst.reactions = {
        ...inst.reactions,
        selectOptionBonus: inst.bonus.store.subscribe((state, action) => {
            if (action.type !== SelectClientActions.types.SELECT_OPTION) return;

            /* Data bonus */
            const { value } = inst.bonus.store.select('select');

            /* Sync store */
            instance.actions.changeData({
                bonus: value
            });

            loadInfoDiscounts(inst);
        })
    };
}

function renderBonus(instance) {
    const { config = {}, store = {} } = instance;
    const { context = {}, literals = {}, select } = config;
    const { bonusLabel = '' } = literals;

    const { route = {}, bonus: bonusStore = {} } = store.select('data');
    const { discounts = [] } = route;

    if (!discounts.length) return html('');

    const { value = 0 } = bonusStore;

    const selectOptionsData = getSelectData(discounts, value);

    const selectData = addData(
        {
            config: {
                ...select,
                literals
            },
            label: bonusLabel,
            items: selectOptionsData
        },
        { type: configuration().type.bonus }
    );

    return SelectTemplate(selectData, context);
}

function renderDiscounts(instance) {
    const { config = {}, store = {} } = instance;
    const { context = {}, literals = {}, select } = config;
    const { discountLabel = '' } = literals;

    const { route = {}, discounts: discountsStore = {} } = store.select('data');
    const { residents = [] } = route;

    if (!residents.length) return html('');

    const { value = 0 } = discountsStore;

    const selectOptionsData = getSelectData(residents, value);

    const selectData = addData(
        {
            config: {
                ...select,
                literals
            },
            label: discountLabel,
            items: selectOptionsData
        },
        { type: configuration().type.discount }
    );

    return SelectTemplate(selectData, context);
}

function destroySelectDiscounts(instance) {
    if (!instance.discounts) return;

    const result = instance;

    result.bonus.actions.destroy();

    instance.reactions.selectOptionDiscount.unsubscribe();

    /* Remove references */
    delete result.reactions.selectOptionDiscount;
    delete result.bonus;
}

function destroySelectBonus(instance) {
    if (!instance.bonus) return;

    const result = instance;

    result.discounts.actions.destroy();

    instance.reactions.selectOptionBonus.unsubscribe();

    /* Remove references */
    delete result.reactions.selectOptionBonus;
    delete result.discounts;
}

function destroyDiscounts(instance) {
    destroySelectDiscounts(instance);
    destroySelectBonus(instance);
}

module.exports = {
    renderDiscounts,
    renderBonus,
    initDiscounts,
    initBonus,
    destroyDiscounts
};
